import {
    ApolloClient,
    InMemoryCache,
} from "@apollo/client";

export const client = new ApolloClient({
    // uri: 'https://kapong-mednote-5000.aquanaut.cils.space/graphql',
    uri: 'https://graphql.api.cils.space/graphql',
    cache: new InMemoryCache()
});